import { useTranslation } from 'react-i18next';

export const StatusChooser = ({onChange, selected = []}) => {
  const { t } = useTranslation();

  const statuses = [
    {name: 'PENDING', value: "pending"},
    {name: 'IN_PROGRESS', value: "in_progress"},
    {name: 'COMPLETED', value: "completed"},
    {name: 'FAILED', value: "failed"},
  ]

  const handleSelect = () => {
    if (statuses.length !== selected.length) {
      onChange(statuses.map(status => status.value))
    } else {
      onChange([])
    }
  }

  return(
    <div className='chooser'>
      <div className='control' onClick={() => handleSelect()}>{statuses.length === selected.length ? t('Deselect all') : t('Select all')}</div>
      <ul>
        {statuses.map(status => {
          return(
            <li key={status.value}>
              <input 
                id={`status_${status.value}`}
                type='checkbox'
                checked={selected.includes(status.value)}
                onChange={() => {
                  if (selected.includes(status.value)) {
                    onChange(selected.filter(v => v !== status.value)) 
                  } else {
                    onChange([...selected, status.value]) 
                  }
                }}
              />
              <label htmlFor={`export_status_${status.value}`}>{t(`export_status_${status.value}`)}</label>
            </li>
          )
        })}
        
      </ul>
    </div>
  )
}
